module.exports = __webpack_public_path__ + "img/bg2.d68ab12e.png";